import React, { useState } from 'react';
import { Accordion, AccordionItem, AccordionItemBody, AccordionItemHeader, ButtonFieldIcon, Iconsvg, Tag, Tooltip, TooltipBody } from '@wk/components-react16';
import DOMPurify from "dompurify";
import { Toast } from '../../services';
import Markdown from 'react-markdown';
import BatchTooltip from './BatchTooltip';

const ResponseTab = ({ data }: any) => {
    const { runPromptResponse, validationResponse = {} } = data;

    const [activeTab, setActiveTab] = useState('response');
    const [isCopy, setIsCopy] = useState(false);


    const handleCopy = async (item: any) => {
        try {
            setIsCopy(true);
            if (activeTab == 'response') {
                await navigator.clipboard.writeText(item.summary);
            } else if (activeTab == 'rationale') {
                await navigator.clipboard.writeText(item.rationale);
            }
            setTimeout(() => {
                setIsCopy(false);
            }, 500);
        } catch (err) {
            Toast('Failed to copy text: ' + activeTab, "error");
        }
    };

    return (
        <div className='custom-tooltip'>
            <ul className="nav nav-pills mb-10" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                    <button
                        className={`nav-link position-relative ${activeTab === 'response' ? 'active' : ''}`}
                        id="pills-response-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-response"
                        type="button"
                        role="tab"
                        aria-controls="pills-response"
                        aria-selected={activeTab === 'response' ? 'true' : 'false'}
                        onClick={() => setActiveTab('response')}
                    >
                        Response
                    </button>
                </li>
                <li className="nav-item" role="presentation">
                    <button
                        className={`nav-link position-relative ${activeTab === 'rationale' ? 'active' : ''}`}
                        id="pills-rationale-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-rationale"
                        type="button"
                        role="tab"
                        aria-controls="pills-rationale"
                        aria-selected={activeTab === 'rationale' ? 'true' : 'false'}
                        onClick={() => setActiveTab('rationale')}
                    >
                        Rationale
                    </button>
                </li>
                <li className="nav-item ms-auto pt-10" role="presentation">
                    {Object.keys(validationResponse).length > 0 && <span id="button-top-right" className="badge rounded-pill border mr-10 text-dark cursor-pointer" style={{ backgroundColor: '#f8d8a6' }}><span className='wk-weight-500'>Validation</span> : {validationResponse.passed_testcases} / {validationResponse.total_testcases}</span>
                    }
                    {/* <ButtonFieldIcon>
                        <button type="button" onClick={() => handleCopy(activeTab)}>
                            <Iconsvg name={isCopy ? "check" : "files"} color='#9A67F3'></Iconsvg>
                        </button>
                    </ButtonFieldIcon> */}
                </li>
            </ul>
            <div className="tab-content border rounded-3 border-primary p-3 bg-white" id="pills-tabContent">
                <div className={`tab-pane fade ${activeTab === 'response' ? 'show active' : ''}`} id="pills-response" role="tabpanel" aria-labelledby="pills-response-tab">
                    {runPromptResponse?.length > 0 ? runPromptResponse?.map((item: any, index: any) => (
                        <div key={index} className={`pt-10 ${index != 0 ? 'border-top' : ''}`}>
                            <h6 id={item.id} className='word-break clearfix'>
                                {item.validations.filter((itm: any) => itm.isSelected).length > 0 && <span id={"button-top-right" + item.id} className="float-end badge rounded-pill border mr-10 text-dark cursor-pointer" style={{ backgroundColor: '#f8d8a6' }}><span className='wk-weight-500'>Validation</span> : {item.validations.filter((itm: any) => itm.status && itm.isSelected).length} / {item.validations.filter((itm: any) => itm.isSelected).length}</span>
                                }
                                <span className="float-end">
                                    <ButtonFieldIcon>
                                        <button type="button" className="p-5 pl-10 pr-10" onClick={() => handleCopy(item)}>
                                            <Iconsvg name={"files"} color='#9A67F3'></Iconsvg>
                                        </button>
                                    </ButtonFieldIcon>
                                </span>

                                {item.name}
                            </h6>
                            <pre>{item.summary}</pre>
                            {item.validations.length > 0 && <BatchTooltip data={item} />}
                        </div>
                    )) : null}
                </div>
                <div className={`tab-pane fade ${activeTab === 'rationale' ? 'show active' : ''}`} id="pills-rationale" role="tabpanel" aria-labelledby="pills-rationale-tab">
                    {runPromptResponse?.length > 0 ? runPromptResponse?.map((item: any, index: any) => (
                        index == 0 && (
                            <div key={index} className={`pt-10 ${index != 0 ? 'border-top' : ''}`}>
                                <h6 id={item.id} className='word-break custom-button-text-left'>
                                    <span className="float-end">
                                        <ButtonFieldIcon>
                                            <button type="button" className="p-5 pl-10 pr-10" onClick={() => handleCopy(item)}>
                                                <Iconsvg name={"files"} color='#9A67F3'></Iconsvg>
                                            </button>
                                        </ButtonFieldIcon>
                                    </span>
                                </h6>
                                <pre>
                                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.rationale, { ALLOWED_TAGS: ["highlight"], }) }}></div>
                                </pre>
                            </div>
                        )
                    )) : null}
                </div>
            </div>
        </div>
    )
}

export default ResponseTab